const sendPixelEvent = (eventType) => {
    console.log('firing!');
    if (!!fbq && typeof fbq === 'function') {
        console.log('sending event');
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        fbq('track', eventType);
    }
};
export default sendPixelEvent;
